import instance from "./index";

export const getAllProjectTypes = async () => {
  const res = await instance.get("/projectType/viewAll");
  const data = res?.data;
  const list = Array.isArray(data)
    ? data
    : Array.isArray(data?.data)
      ? data.data
      : [];

  return list.map((item) => ({
    ...item,
    projectType:
      item.projectType ??
      item.projectTypeName ??
      item.name ??
      "",
    projectTypeId:
      item.projectTypeId ??
      item.id ??
      item.Id ??
      null,
  }));
};

export const createProjectType = async (projectType) => {
  const trimmed = String(projectType ?? "").trim();
  if (!trimmed) throw new Error("Project type is required");

  const res = await instance.post("/projectType", { projectType: trimmed });
  const data = res?.data?.data ?? res?.data ?? {};

  return {
    ...data,
    projectType: data.projectType ?? data.projectTypeName ?? trimmed,
    projectTypeId:
      data.projectTypeId ??
      data.id ??
      data.Id ??
      null,
  };
};
